import { render, staticRenderFns } from "./r-item-shop-product-table.vue?vue&type=template&id=3c8af3ce"
import script from "./r-item-shop-product-table.vue?vue&type=script&lang=js"
export * from "./r-item-shop-product-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8af3ce')) {
      api.createRecord('3c8af3ce', component.options)
    } else {
      api.reload('3c8af3ce', component.options)
    }
    module.hot.accept("./r-item-shop-product-table.vue?vue&type=template&id=3c8af3ce", function () {
      api.rerender('3c8af3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-shop/r-item-shop-product-table.vue"
export default component.exports